import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "list-settings-sublist",
  templateUrl: "./list-settings-sublist.component.html",
  styleUrls: ["./list-settings-sublist.component.scss"],
})
export class ListSettingsSublistComponent implements OnInit {
  @Input() sublistTitle: string;
  @Input() sublistItems;
  @Input() selectedItem;
  @Input() criteria: string;
  @Input() criteriaValue: boolean;
  @Input() showDeleteCriteriaValue: boolean;
  @Input() type: string;
  @Output() selectItem = new EventEmitter();
  @Output() confirmedDelete = new EventEmitter();

  clickedDeleteSublistItemId: string;
  constructor() {}

  ngOnInit() {}

  deleteSublistItem(deleteConfirmed, sublistItem) {
    if (deleteConfirmed) {
      this.confirmedDelete.emit(sublistItem);
    }
    this.clickedDeleteSublistItemId = null;
  }

  itemIsShared(sublistItem) {
    return (
      sublistItem["sharedWithAdmins"] ||
      (sublistItem["sharedWithSchoolLeadersAtSchoolIds"] &&
        sublistItem["sharedWithSchoolLeadersAtSchoolIds"].length > 0) ||
      (sublistItem["sharedWithTeachersAtSchoolIds"] &&
        sublistItem["sharedWithTeachersAtSchoolIds"].length > 0)
    );
  }
}
